import { HtmlHTMLAttributes, memo } from 'react';

import Skeleton from 'react-loading-skeleton';
import { FiHeart, FiMessageCircle } from 'react-icons/fi';

import * as S from '../styles';

const generateRandomBoolean = () => Boolean(Math.round(Math.random()));

const PostLoading = (attrs: HtmlHTMLAttributes<HTMLLIElement>) => (
  <S.Container $active={false} $loading $deleting={false} {...attrs}>
    <S.PostHeader>
      <div>
        <Skeleton width="2.75rem" height="2.75rem" circle />

        <div>
          <h3>
            <Skeleton width="10rem" />
          </h3>
          <time>
            <Skeleton width="5rem" />
          </time>
        </div>
      </div>
    </S.PostHeader>

    <S.PostMain>
      {generateRandomBoolean() && <Skeleton width="100%" count={2} />}
      <Skeleton width="60%" />
    </S.PostMain>

    {generateRandomBoolean() && (
      <S.PostImageWrapper>
        <Skeleton width="100%" height="14rem" />
      </S.PostImageWrapper>
    )}

    <S.PostStats>
      <S.PostStat>
        <Skeleton width="3rem" />
      </S.PostStat>
      <S.PostStat>
        <Skeleton width="3rem" />
      </S.PostStat>
    </S.PostStats>

    <S.PostFooter>
      <S.PostFooterActions $commentsVisible={false} $voted={false}>
        <button type="button" disabled>
          <FiHeart size="1.125rem" />
          Curtir
        </button>

        <button type="button" disabled>
          <FiMessageCircle size="1.125rem" />
          Comentar
        </button>
      </S.PostFooterActions>
    </S.PostFooter>
  </S.Container>
);

export default memo(PostLoading);
